/**
 * STEMO: Localize Pareto quantity-break widget copy using theme locale strings.
 * Pareto often stays in English when market/locale detection mismatches.
 */
(function () {
  const EN_ATC = new Set(["Add to cart", "Add to Cart", "ADD TO CART"]);
  let scheduled = false;

  function strings() {
    return window.themeVariables?.strings || {};
  }

  function translatePhrase(raw) {
    const s = strings();
    let text = raw.replace(/\s+/g, " ").trim();
    if (!text) return null;

    const original = text;
    if (EN_ATC.has(text)) return s.addToCartButton || text;

    text = text.replace(/grab this deal/gi, s.paretoGrabDeal || "Grab this deal");
    text = text.replace(/buy\s+(\d+)/gi, function (_, count) {
      return (s.paretoBuy || "Buy {{ count }}").replace("{{ count }}", count);
    });
    text = text.replace(/get each for/gi, s.paretoGetEachFor || "Get each for");

    return text === original ? null : text;
  }

  function walk(node) {
    if (!node) return;
    if (node.nodeType === Node.TEXT_NODE) {
      const next = translatePhrase(node.textContent);
      if (next !== null) {
        node.textContent = node.textContent.replace(node.textContent.trim(), next);
      }
      return;
    }
    if (node.nodeType !== Node.ELEMENT_NODE) return;
    if (node.matches && node.matches("script, style")) return;
    node.childNodes.forEach(walk);
  }

  function scan() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      document
        .querySelectorAll(".omg-groupsTable, [id*='p_quantity_breaks'], [class*='quantity_break'], [class*='quantity-break']")
        .forEach(walk);
      document.querySelectorAll("button, a, [role='button']").forEach((el) => {
        const next = translatePhrase(el.textContent);
        if (next) el.textContent = next;
      });
    });
  }

  function init() {
    scan();
    new MutationObserver(scan).observe(document.body, { childList: true, subtree: true });
    document.addEventListener("shopify:section:load", scan);
    window.addEventListener("load", scan);
    setTimeout(scan, 500);
    setTimeout(scan, 1500);
    setTimeout(scan, 3000);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
